import "./style/home.scss"

import React from "react"
import lazyloadHelper from "@ng-mw/shared-react-components/lazyloadHelper"
import { LocalStorage } from "@ng-mw/shared-react-components"
import { HomepageTypes } from "@modules/debug/DebugAltHomePage"

// Components
import Spinner from "@ng-mw/reol/components/Spinner"
import { useSelector } from "react-redux"
import { RootState } from "@app/types"
import HomeSkeleton from "./HomeSkeleton"

const { WithSuspense: StandardHome } = lazyloadHelper(
    () => import(/* webpackChunkName: "StandardHome" */ "./StandardHome"),
    <Spinner />,
)
const { WithSuspense: MinimalHome } = lazyloadHelper(
    () => import(/* webpackChunkName: "MinimalHome" */ "./MinimalHome"),
    <Spinner />,
)

const Home = () => {
    const selected: HomepageTypes = LocalStorage.get("DEBUG_ALT_HOMEPAGE")

    const waitingForToken = useSelector((state: RootState) => state.app.waitingForToken)

    if (waitingForToken) {
        return <HomeSkeleton />
    }

    switch (selected) {
        case "Empty":
            return <div>Blank homepage. (For performance testing)</div>

        case "Minimal":
            return <MinimalHome />

        case "Standard":
        default:
            return <StandardHome />
    }
}

export default Home
